<div class="banner d-lg-flex d-none" role="banner">
  <h1>{{ 'account.activity.page.title' | translate }}</h1>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgb-account-nav></fgb-account-nav>

<div class="container pt-4">
  <div class="points-history">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.loyalty]" [accountView]="true"></fgb-transaction-history>
  </div>
</div>
